import CustomizationUtils from "./CustomizationUtils";
var CustomizeRouterListener = /** @class */ (function () {
    function CustomizeRouterListener(router, customization) {
        this._customization = customization;
        this._router = router;
        router.addListener(this);
    }
    Object.defineProperty(CustomizeRouterListener.prototype, "router", {
        get: function () {
            return this._router;
        },
        enumerable: false,
        configurable: true
    });
    CustomizeRouterListener.prototype.onContentLoadingError = function (error, oldPath, newPath) {
    };
    CustomizeRouterListener.prototype.onContentLoadingSuccess = function (oldPath, newPath) {
    };
    CustomizeRouterListener.prototype.onJsLoadingError = function (error, oldPath, newPath) {
    };
    CustomizeRouterListener.prototype.onJsLoadingSuccess = function (oldPath, newPath) {
    };
    CustomizeRouterListener.prototype.onLoadingProgress = function (globalProgress, details) {
    };
    CustomizeRouterListener.prototype.onPreLoading = function (newPath) {
        CustomizationUtils.applyCssCustomization(this._customization, newPath !== null && newPath !== void 0 ? newPath : '');
        CustomizationUtils.applyJSLoadCustomization(this._customization, newPath !== null && newPath !== void 0 ? newPath : '');
    };
    CustomizeRouterListener.prototype.onUnloading = function (oldPath) {
        CustomizationUtils.applyJSUnloadCustomization(this._customization, oldPath !== null && oldPath !== void 0 ? oldPath : '');
    };
    CustomizeRouterListener.prototype.onUnloadingFinished = function (path) {
        console.log(path);
    };
    return CustomizeRouterListener;
}());
export { CustomizeRouterListener };
//# sourceMappingURL=CustomizeRouterListener.js.map